import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { Favorites, FavoritesService } from "../service/favorites.service";
import { CommonModule } from "@angular/common";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatButtonModule } from "@angular/material/button";
import { Router } from "@angular/router";
import { AuthService } from "../service/auth.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";

interface Aircraft {
  id: string;
  code: string;
  model: string;
}

interface Instructor {
  id: string;
  name: string;
}

@Component({
  standalone: true,
  imports: [
    CommonModule,
    HttpClientModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  selector: "app-favorites",
  templateUrl: "./favorites.component.html",
  styleUrls: ["./favorites.component.scss"],
})
export class FavoritesComponent implements OnInit {
  aircrafts: Aircraft[] = [];
  instructors: Instructor[] = [];

  selectedAircrafts = new Set<string>();
  selectedInstructors = new Set<string>();

  loading = true;
  saving = false;

  selfOnlyInstructor = false;
  isInstructor = false;

  constructor(
    private favService: FavoritesService,
    public authService: AuthService,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.loadAll();
  }

  loadAll() {
    this.loading = true;

    Promise.all([
      this.http.get<Aircraft[]>("/api/aircraft").toPromise(),
      this.http.get<Instructor[]>("/api/instructor/all").toPromise(),
      this.favService.getFavorites().toPromise(),
    ]).then(([aircrafts, instructors, favorites]) => {
      this.aircrafts = aircrafts;

      const myInstructorId = this.authService.currentUser?.instructorId;

      // Supprimer l’instructeur courant de la liste
      this.instructors = (instructors ?? []).filter(
        (i) => i.id !== myInstructorId
      );

      this.selectedAircrafts = new Set(favorites.aircraftIds);
      this.selectedInstructors = new Set(favorites.instructorIds);
      this.selfOnlyInstructor = favorites?.selfOnlyInstructor ?? false;
      this.isInstructor = this.authService.currentUser?.role === "INSTRUCTOR";
      this.loading = false;
    });
  }

  toggleAircraft(id: string) {
    if (this.selectedAircrafts.has(id)) this.selectedAircrafts.delete(id);
    else this.selectedAircrafts.add(id);
  }

  toggleInstructor(id: string) {
    if (this.selectedInstructors.has(id)) this.selectedInstructors.delete(id);
    else this.selectedInstructors.add(id);
  }

  onToggleSelfOnly() {
    if (this.selfOnlyInstructor) {
      // On garde seulement l’instructeur courant
      const myInstructorId = this.authService.currentUser?.instructor?.id;
      this.selectedInstructors = new Set(
        myInstructorId ? [myInstructorId] : []
      );
    }
  }

  save() {
    this.saving = true;
    const payload: Favorites = {
      aircraftIds: [...this.selectedAircrafts],
      instructorIds: [...this.selectedInstructors],
      selfOnlyInstructor: this.isInstructor
        ? this.selfOnlyInstructor
        : undefined,
    };
    this.favService.updateFavorites(payload).subscribe({
      next: () => {
        this.saving = false;
        // alert("Préférences sauvegardées ✅");
        this.router.navigateByUrl("/");
      },
      error: () => {
        this.saving = false;
        // alert("Erreur lors de la sauvegarde ❌");
      },
    });
  }

  cancel() {
    this.router.navigateByUrl("/"); // 👈 redirige vers la page principale (BookingComponent)
  }
}
